import React from 'react';
import { Typography, Switch, Select, Form, message, Skeleton } from 'antd';
import { SettingOutlined } from '@ant-design/icons';
import { useGetPreferencesQuery, useUpdatePreferencesMutation } from './notificationsApi';

const { Title, Text } = Typography;

function PrefCard({ title, children }) {
  return (
    <div
      style={{
        marginBottom: 16,
        borderRadius: 12,
        border: '1px solid var(--df-border)',
        background: 'var(--df-surface-elevated)',
        boxShadow: 'var(--df-shadow)',
        padding: '20px 22px',
      }}
    >
      <Text
        strong
        style={{
          display: 'block',
          marginBottom: 16,
          fontFamily: 'var(--df-font-display)',
          fontSize: 15,
          color: 'var(--df-text)',
        }}
      >
        {title}
      </Text>
      {children}
    </div>
  );
}

export default function NotificationPreferencesPage() {
  const { data: prefs, isLoading } = useGetPreferencesQuery();
  const [updatePrefs] = useUpdatePreferencesMutation();

  const toggle = async (field, value) => {
    await updatePrefs({ [field]: value });
    message.success('Preference updated');
  };

  if (isLoading) {
    return <Skeleton active paragraph={{ rows: 8 }} />;
  }

  return (
    <div style={{ maxWidth: 640 }}>
      <section style={{ marginBottom: 24 }}>
        <Title
          level={3}
          style={{ margin: 0, fontFamily: 'var(--df-font-display)', color: 'var(--df-text)' }}
        >
          <SettingOutlined style={{ marginRight: 10, color: 'var(--df-primary)' }} />
          Notification preferences
        </Title>
        <Text style={{ display: 'block', marginTop: 6, color: 'var(--df-text-secondary)' }}>
          Control email, in-app, and digest delivery without leaving DealFusion.
        </Text>
      </section>

      <PrefCard title="Email notifications">
        <Form layout="vertical">
          <Form.Item label="Deal alerts" style={{ marginBottom: 14 }}>
            <Switch checked={prefs?.emailDealAlerts} onChange={(v) => toggle('emailDealAlerts', v)} />
          </Form.Item>
          <Form.Item label="Comment replies" style={{ marginBottom: 14 }}>
            <Switch checked={prefs?.emailCommentReplies} onChange={(v) => toggle('emailCommentReplies', v)} />
          </Form.Item>
          <Form.Item label="Votes received" style={{ marginBottom: 14 }}>
            <Switch checked={prefs?.emailVotes} onChange={(v) => toggle('emailVotes', v)} />
          </Form.Item>
          <Form.Item label="Daily digest" style={{ marginBottom: 0 }}>
            <Switch checked={prefs?.emailDigest} onChange={(v) => toggle('emailDigest', v)} />
          </Form.Item>
        </Form>
      </PrefCard>

      <PrefCard title="In-app notifications">
        <Form layout="vertical">
          <Form.Item label="Deal alerts" style={{ marginBottom: 14 }}>
            <Switch checked={prefs?.inAppDealAlerts} onChange={(v) => toggle('inAppDealAlerts', v)} />
          </Form.Item>
          <Form.Item label="Comment replies" style={{ marginBottom: 14 }}>
            <Switch checked={prefs?.inAppCommentReplies} onChange={(v) => toggle('inAppCommentReplies', v)} />
          </Form.Item>
          <Form.Item label="Votes received" style={{ marginBottom: 0 }}>
            <Switch checked={prefs?.inAppVotes} onChange={(v) => toggle('inAppVotes', v)} />
          </Form.Item>
        </Form>
      </PrefCard>

      <PrefCard title="Delivery">
        <Form layout="vertical">
          <Form.Item label="Digest frequency" style={{ marginBottom: 14 }}>
            <Select
              value={prefs?.digestFrequency || 'daily'}
              onChange={(v) => toggle('digestFrequency', v)}
              style={{ width: 200 }}
              options={[
                { value: 'daily', label: 'Daily' },
                { value: 'weekly', label: 'Weekly' },
              ]}
            />
          </Form.Item>
          <Form.Item label="Browser push notifications" style={{ marginBottom: 0 }}>
            <Switch checked={prefs?.browserPush} onChange={(v) => toggle('browserPush', v)} />
          </Form.Item>
        </Form>
      </PrefCard>
    </div>
  );
}
